// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3As-l","notes":"Notes_notes__1fmiU"};